import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FileType } from '../../../core/model/file';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { FileManagerService } from '../../../core/services/files/file-manager.service';

@Component({
  selector: 'app-list-file-viewer',
  templateUrl: './list-file-viewer.component.html',
  styleUrls: ['./list-file-viewer.component.css']
})
export class ListFileViewerComponent implements OnInit {

  @ViewChild('fileInput') fileInput;

  @Input() divClassName = '';
  @Input() set filesDatas(files: { name: string, guid: string, date: string, fileData: any }[]) {
    this.files = files;
    console.log(files);
  }

  private _files: { name: string, guid: string, date: string, fileData: any }[] = [];
  @Input() set files(files: { name: string, guid: string, date: string, fileData: any }[]) {
    this._files = files;
  }
  get files(): { name: string, guid: string, date: string, fileData: any }[] {
    return this._files;
  }
  @Input() canShare = false;
  @Input() removeElements = false;
  @Input() canUploadFiles = false;
  @Input() idContenido = 0;
  @Output() removeElementsEvent = new EventEmitter<{ name: string, guid: string, date: string, fileData: any }[]>();
  @Output() subirFichero = new EventEmitter<string>();
  @Output() fileUploaded = new EventEmitter<string>();
  @Output() fileInventoryUploaded = new EventEmitter<string>();
  @Output() fileReplaced = new EventEmitter<{ newGuid: string, oldGuid: string }>();
  @Input() inventariar = false;
  loading = false;

  constructor(
    private fileManagerService: FileManagerService,
    private toastr: ToastrService,
    private authService: AuthenticationService

  ) { }

  ngOnInit() {

  }

  removeElement(file: { name: string, guid: string, date: string, fileData: any }) {
    const element = this.files.find(fil => fil.name == file.name && fil.guid == file.guid && fil.date == file.date);
    this.removeElementsEvent.emit([element]);
  }

  removeAllFiles() {
    this.removeElementsEvent.emit(this.files);
  }

  obtenerExtension(nombreFichero: string): string {
    return nombreFichero.substr(nombreFichero.lastIndexOf('.') + 1).toLowerCase();
  }

  uploadFile(guid: string) {
    this.fileUploaded.emit(guid);
  }
  replaceFile(replacement: { newGuid: string, oldGuid: string }) {
    this.fileReplaced.emit(replacement);
  }

  upLoadFiles() {
    this.loading = true;

    for (let file of this.fileInput.nativeElement.files) {
      // addFileAndOCRToRepo
      if (!this.inventariar) {
        this.fileManagerService.uploadFileToRepository(file, true, FileType.CARGA_MASIVA).subscribe(guid => {
          this.loading = false;
          this.fileUploaded.emit(guid);
          this.toastr.clear();
          this.toastr.success('Se ha subido correctamente el fichero al repositorio', 'Fichero subido correctamente');
        },
          error => {
            this.loading = false;
            this.toastr.clear();
            this.toastr.error('Se ha producido un error al subir el fichero al repositorio', 'Error al subir el fichero');
          });
      } else {
        // Si se marca el inventariar, hay que guardarlo a través del OCR para que el disponga automáticamente que accion realizar
        // no habría que realizar la accion posterior de asociarlo con el contenido, ya lo hace este servicio
        this.fileManagerService.addFileAndOCRToRepo(file, this.idContenido, this.authService.getIdiomaUser()).subscribe(guid => {
          this.loading = false;
          this.fileInventoryUploaded.emit(guid);
          this.toastr.clear();
          this.toastr.success('Se ha subido correctamente el fichero al repositorio', 'Fichero subido correctamente');
        },
          error => {
            this.loading = false;
            this.toastr.clear();
            this.toastr.error('Se ha producido un error al subir el fichero al repositorio', 'Error al subir el fichero');
          });
      }
    }

  }


}